import React from 'react';
import S from './RichText.styles';
const RichText = ({ content, leadParagraph = false }) => {
    return (React.createElement(S.Container, { isActive: true, innerWidth: "narrow" },
        React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: content }, leadParagraph: leadParagraph })));
};
export default RichText;
